import { useEffect, useState } from 'react';
import { UserApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { PublicUserWithBirthday } from '../../../commonTypes/user.types';

const useHttpGetColleaguesBirthdaysOnMount = (from: string, to: string) => {
    const userApi: UserApi = useContainer(UserApi);
    const [isReady, setIsReady] = useState(false);
    const [data, setData] = useState<PublicUserWithBirthday[]>([]);

    useEffect(() => {
        const { exec, abort } = userApi.getColleaguesBirthdays({
            query: { from, to },
            onSuccess: res => setData(res.body),
            onFinally: () => setIsReady(true),
        });
        exec();
        return abort;
    }, []);
    return { isReady, data };
};

export default useHttpGetColleaguesBirthdaysOnMount;
